const FLICKER_API_HOST = 'https://api.flickr.com/services/rest/';

const FLICKR_API_KEY = 'dbb6d113ef5fcb40f714ddb088122345';
const FLICKR_USER_ID = '147661892%40N04';
const FILCKR_SIGN_KEY = '2be159006ca2fd9f079003ff9dfe1c19';

const SMALL_SQUARE_IMAGE_75x75 = 's';
const LARGE_SQUARE_IMAGE_150x150 = 'q';


const DETAIL_METHOD = "flickr.photosets.getPhotos";
const GALLERY_METHOD = "flickr.photosets.getList";

//thumbnail, 100 on longest side
const THUMBNAIL_IMAGE = 't';

//240 on longest side
const IMAGE_SMALL = 's';

//320 on longest side
const IMAGE_SMALL_N = 'n';

//500 on longest side
const IMAGE_MEDIUM = '-';

//640 on longest side
const IMAGE_MEDIUM_Z = 'z';

//800 on longest side†
const IMAGE_MEDIUM_C = 'c';

//10s24 on longest side*
const IMAGE_LARGE_B = 'b';

//1600 on longest side†
const IMAGE_LARGE_H = 'h';

//2048 on longest side†
const IMAGE_LARGE_K = 'k';

//original image, either a jpg, gif or png, depending on source format
const ORIGINAL_IMAGE_SIZE = 'o';

export {
    FLICKER_API_HOST,
    FLICKR_API_KEY,
    FLICKR_USER_ID,
    FILCKR_SIGN_KEY,
    SMALL_SQUARE_IMAGE_75x75,
    LARGE_SQUARE_IMAGE_150x150,
    THUMBNAIL_IMAGE,
    IMAGE_SMALL,
    IMAGE_SMALL_N,
    IMAGE_MEDIUM,
    IMAGE_MEDIUM_C,
    IMAGE_MEDIUM_Z,
    IMAGE_LARGE_B,
    IMAGE_LARGE_H,
    IMAGE_LARGE_K,
    ORIGINAL_IMAGE_SIZE,
    DETAIL_METHOD,
    GALLERY_METHOD
}